export default __webpack_public_path__ + "static/media/vetor2.8e549edf.png";